export default __webpack_public_path__ + "static/android-live-3fbcf0b647ceb48f26c4be0bfb84cee3.png";